module.exports = __webpack_public_path__ + "img/outlet-green.8e89b864.svg";